import CreateReducer from '../../misc/CreateReducer';
import {ActionTypes} from '../ActionTypes';
/**
 * This reducer is used for monitoring the sign up state.
 */

const initialStateAuth = {
  data: false,
};
export const isAuthorized = CreateReducer(
  initialStateAuth,
  {
    [ActionTypes.SET_UN_AUTHORIZED_TYPE]: (state, action) => {
      return Object.assign({}, state, action);
    },
  },
  true,
);

const initialStateSeen = {
  data: false,
};
export const seenOnboarding = CreateReducer(
    initialStateSeen,
    {
      [ActionTypes.SET_SEEN_ONBOARDING]: (state, action) => {
        return Object.assign({}, state, action);
      },
    },
    true,
);

const initialState = {
  isLoading: false,
  message: 'hello',
  failed: false,
};
export const signup = CreateReducer(
  initialState,
  {
    [ActionTypes.SIGNUP_REQUEST]: (state, action) => {
      return Object.assign({}, state, action);
    },
    [ActionTypes.SIGNUP_SUCCESS]: (state, action) => {
      var data = Object.assign({}, state, action);
      delete data.data;
      return data;
    },
    [ActionTypes.SIGNUP_FAILURE]: (state, action) => {
      return Object.assign({}, state, action);
    },
  },
  true,
);

/**
 * This is used to monitor the authentication
 * status of the mobile app.
 */
export const auth = CreateReducer(
  {
    isLoading: false,
    hasFetched: false,
    isLoggedIn: false,
    data: null,
    message: null,
    failed: false,
  },
  {
    [ActionTypes.LOGIN_REQUEST]: (state, action) => {
      return Object.assign({}, state, action);
    },
    [ActionTypes.LOGIN_SUCCESS]: (state, action) => {
      return Object.assign({}, state, action);
    },
    [ActionTypes.LOGIN_FAILURE]: (state, action) => {
      return Object.assign({}, state, action);
    },

    [ActionTypes.GET_AUTHENTICATED_SUCCESS]: (state, action) => {
      return Object.assign({}, state, {
        data: action.data,
        isLoggedIn: action.data != null,
        isFetching: false,
        hasFetched: true,
        failed: false,
        message: null,
      });
    },
    [ActionTypes.GET_AUTH_USER_SUCCESS]: (state, action) => {
      return Object.assign({}, state, {
        data: action.data,
        isLoggedIn: true,
      });
    },
    [ActionTypes.SIGNUP_SUCCESS]: (state, action) => {
      return Object.assign({}, state, {
        data: action.data,
        isLoggedIn: true,
        isFetching: false,
        failed: false,
        message: null,
      });
    },
    [ActionTypes.LOGOUT_REQUEST]: (state, action) => {
      return Object.assign({}, state, {
        data: null,
        isLoggedIn: false,
        isFetching: false,
        failed: false,
        message: null,
      });
    },
    [ActionTypes.STORE_USER_SUCCESS]: (state, action) => {
      var data = Object.assign({}, state);
      data.data = Object.assign({}, data.data, action.data);
      return data;
    },
  },
  true,
);
